import { getStrapiUrl } from "@/lib/app-config";

// Media URLs from Strapi may be relative (local provider) or absolute (S3/CDN).
// Resolve relative paths against the API origin so downloads work in every setup.
export function resolveMediaUrl(url?: string): string | undefined {
  if (!url) return undefined;
  if (/^https?:\/\//i.test(url)) return url;
  return `${getStrapiUrl()}${url.startsWith("/") ? "" : "/"}${url}`;
}

export function formatFileSize(bytes: number): string {
  if (!bytes || bytes < 0) return "—";
  if (bytes < 1024 * 1024) return `${Math.max(1, Math.round(bytes / 1024))} ك.ب`;
  return `${(bytes / (1024 * 1024)).toFixed(1)} م.ب`;
}
